import React, { Component, Fragment } from 'react';
import {convertTwoDecimalPoint, 
    calculateStripeCharges, _addNotificationError,_addNotification, getPaymentGateway, 
    getMurchantPayChargesStatus, numberParce, getLoginParent, getSalesTaxStatus, getSalesTaxAmount,getTotalAmountIncludeSalesTax, getSalesTaxRate} from '../../../server/util';
import moment from 'moment';
import CustomSubmit from '../../Misc/customSubmit';
class PaySummary extends Component {
    totalOrderAmount=()=>{
        let totPrice=0.00;
            Object.keys(this.props.price).map((priceItem,i)=>{
                totPrice+=this.monthlyAmount(this.props.price[priceItem],'TOTAL');
            })            
        return totPrice -this.totInitPrice();
    }
    totInitPrice=()=>{     
        const {initialPrices}=this.props;   
        let prevPaid=0.00;
        Object.keys(initialPrices).map((priceItem,i)=>{
            prevPaid+= this.monthlyAmount(this.props.initialPrices[priceItem],'TOTAL');
        })
        return prevPaid;
    }
    monthlyAmount=(price,action)=>{
        const {studentData, isParent}= this.props;
        const initPrice=parseFloat(convertTwoDecimalPoint(price,1));
        const sid=isParent?studentData.mealSchoolId||0:0;
        if(getSalesTaxStatus(sid)){
            if(action==='TOTAL'){
             return getTotalAmountIncludeSalesTax(initPrice,getSalesTaxRate(sid))
            }else{
                return getSalesTaxAmount(initPrice,getSalesTaxRate(sid))
            }
        }else{
            return initPrice
        }
    }
    totalOrderAmountExcludeSalesTax=()=>{
        let totPrice=0.00;
            Object.keys(this.props.price).map((priceItem,i)=>{
                totPrice+=parseFloat(convertTwoDecimalPoint(this.props.price[priceItem],2));
            })
        return (totPrice) -this.totInitPriceExcludeSalesTax();
    }
    totInitPriceExcludeSalesTax=()=>{
        let prevPaid=0.00;
        Object.keys(this.props.initialPrices).map((priceItem,i)=>{
            prevPaid+=parseFloat(convertTwoDecimalPoint(this.props.initialPrices[priceItem],2));
        })
        return prevPaid;
    }
    calculateSalesTax=()=>{
        const {isParent, studentData}=this.props;
        const saleTaxAmount=getSalesTaxAmount(this.totalOrderAmount(),getSalesTaxRate(isParent?studentData.mealSchoolId:0));
        if(this.totalOrderAmount()<=0){
            return 0.00;
        }else{
            return saleTaxAmount;
        }
    }
    render() {
        const {price, initialPrices, isParent, studentData}=this.props;        
        return (<Fragment>  
            <div className='row' style={{margin: '10px auto'}}>
                <div className="col-xs-12 col-md-4">
                    <div className="text-left" >
                        <h4 style={{marginBottom:'3px'}}>{'Payment Summary'}</h4>
                    </div>
                </div>
                <div className='col-xs-12 col-md-8 text-right'>
                <button type="button" className="btn btn-sm btn-info" style={window.innerWidth<=500? {width:'100%'}:{}} 
                    onClick={(e)=>{
                        this.props.onBackOrderReview(e)
                    }}>Back to Review Order</button>

                <CustomSubmit id="orderSubmit" type="button" className="btn btn-success btn-sm"
                        style={window.innerWidth<=500? {width:'100%',margin: 0,marginLeft: 5,fontSize: 14,}: {
                            margin: 0,marginLeft: 5,fontSize: 14,
                        }} 
                        handleSubmit={(e,callback) => 
                        {
                            this.props.onSubmitPayment({"salesTaxAmt":this.calculateSalesTax()}, callback)
                            //this.onStudentDataSubmit(e,callback)
                        }}>
                        <i className="glyphicon glyphicon-ok"></i> Submit</CustomSubmit>
                                       
                </div>
            </div>          
            <div className="row">
                <div className="col-md-offset-3 col-md-6">
                    <div className="table-responsive">
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>Month Year</th>
                                    <th style={{width:'150px', textAlign:'right'}}>Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                            {
                                Object.keys(price).map((priceItem,i)=>{
                                    return <Fragment>
                                        <tr key={i+1}>
                                        <td>{moment(priceItem,'YYYYMM').format('MMM-YY')}</td>
                                        <td style={{width:'150px', textAlign:'right'}}>{`${this.props.currency_symbol} ${convertTwoDecimalPoint(this.monthlyAmount(price[priceItem],'TOTAL'),2)}`}</td>                                
                                    </tr>
                                    {
                                       ((initialPrices[priceItem])||0)>0 &&
                                        <tr key={`a-${(i+1)}`}>
                                        <td>{`Already paid on ${moment(priceItem,'YYYYMM').format('MMM-YY')}`}</td>
                                        <td style={{width:'150px', textAlign:'right'}}>{`(-) ${this.props.currency_symbol} ${convertTwoDecimalPoint(this.monthlyAmount(initialPrices[priceItem],'TOTAL'),2)}`}</td>                                
                                    </tr>
                                    }
                                </Fragment>
                                })
                            }
                            </tbody>
                            <tfoot style={{backgroundColor: '#f7f6f6',fontWeight: 600}}>
                                {
                                    getSalesTaxStatus(isParent?studentData.mealSchoolId:0)?
                                    <tr>
                                        <td>Sales Tax</td>
                                        <td style={{width:'150px', textAlign:'right'}}>{`${this.props.currency_symbol} ${convertTwoDecimalPoint(this.calculateSalesTax(),2)}`}</td>
                                    </tr>:
                                null
                                }
                                
                                <tr>
                                    <td>Total Amount</td>
                                    <td style={{width:'150px', textAlign:'right'}}>{`${this.props.currency_symbol} ${convertTwoDecimalPoint(this.totalOrderAmount(),2)}`}</td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>                
            </div>
            {/* <div className="row">
                <div className="col-md-6">
                    <button type="button" className="btn btn-sm btn-success" onClick={(e)=>{
                        this.props.onBackOrderReview(e)
                    }}>Back</button>
                </div>
                <div className="col-md-6 text-right">
                    <CustomSubmit id="orderSubmit" type="button" className="btn btn-success btn-lg"
                        style={{
                            margin: 0,marginLeft: 5,fontSize: 14,
                        }} 
                        handleSubmit={(e,callback) => 
                        {
                            this.props.onSubmitPayment({"salesTaxAmt":this.calculateSalesTax()}, callback)
                            //this.onStudentDataSubmit(e,callback)
                        }}>
                        <i className="glyphicon glyphicon-ok"></i> Submit</CustomSubmit>
                </div>
            </div> */}
        </Fragment>
        );
    }
}

export default PaySummary;


// WEBPACK FOOTER //
// ./src/components/Parent/ManageOrders/paySummary.jsx